export default "__VITE_ASSET__DQSM5bKI__"